<template>
  <div class="upload-file-wrapper">
    <div class="progress" v-if="progress > 0">
      <el-progress :percentage="progress" :stroke-width="2" />
    </div>
    <div class="file-list" v-if="showFileList && fileList.length > 0">
      <div class="file-item" v-for="(file, index) in fileList" :key="index">
        <span class="file-name">{{ file.name }}</span>
        <el-button 
          type="text" 
          size="small" 
          class="delete-btn"
          @click="removeFile(index)"
        >
          <i class="el-icon-delete"></i>
        </el-button>
      </div>
    </div>
    <el-upload
      class="upload-demo"
      action=""
      :auto-upload="false"
      :show-file-list="false"
      :on-change="handleFileChange"
      multiple
    >
      <el-button size="small" type="primary">
        {{ $t('common.upload') }}
      </el-button>
    </el-upload>
  </div>
</template>

<script>
import { uploadFile } from '@/api/system/paymentPoolApi'

export default {
  name: 'UploadFile',
  props: {
    callBackListener: {
      type: String,
      default: ''
    },
    callBackFunction: {
      type: String,
      default: ''
    },
    showFileList: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      progress: 0,
      fileList: [],
      uploadingFiles: []
    }
  },
  methods: {
    clear() {
      this.progress = 0
      this.fileList = []
      this.uploadingFiles = []
    },
    removeFile(index) {
      this.fileList.splice(index, 1)
      this.uploadingFiles.splice(index, 1)
      this.$emit('fileRemoved', index)
    },
    handleFileChange(file) {
      if (file.size > 20 * 1024 * 1024) {
        this.$message.error(this.$t('uploadFile.sizeLimit'))
        return false
      }
      
      // 检查是否已存在同名文件
      const exists = this.fileList.some(f => f.name === file.name)
      if (exists) {
        this.$message.warning('文件已存在：' + file.name)
        return
      }
      
      this.fileList.push({
        name: file.name,
        raw: file.raw
      })
      this.doUpload(file.raw)
    },
    setFilePath(fileName) {
      const fileIndex = this.fileList.findIndex(f => f.name === fileName)
      if (fileIndex > -1) {
        this.fileList[fileIndex].realFileName = fileName
        this.fileList[fileIndex].progress = 100
      }
    },
    async doUpload(file) {
      const formData = new FormData()
      formData.append('uploadFile', file)
      
      try {
        const config = {
          onUploadProgress: progressEvent => {
            const percent = Math.round(
              (progressEvent.loaded * 100) / progressEvent.total
            )
            this.progress = percent < 90 ? percent : 90
          }
        }
        
        const data = await uploadFile(formData, config)
        
        // 更新对应文件的信息
        const fileIndex = this.fileList.findIndex(f => f.name === file.name)
        if (fileIndex > -1) {
          this.fileList[fileIndex].realFileName = data.realFileName
          this.fileList[fileIndex].progress = 100
        }
        
        this.uploadingFiles.push({
          fileName: file.name,
          realFileName: data.realFileName
        })
        
        this.progress = 100
        this.$emit('notify', data)
        
        if (this.callBackListener && this.callBackFunction) {
          this.$emit(this.callBackFunction, data)
        }
        
        this.$message.success(this.$t('uploadFile.success'))
      } catch (error) {
        this.$message.error(this.$t('uploadFile.error'))
        console.error('上传文件失败:', error)
        // 移除上传失败的文件
        const fileIndex = this.fileList.findIndex(f => f.name === file.name)
        if (fileIndex > -1) {
          this.fileList.splice(fileIndex, 1)
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.upload-file-wrapper {
  .progress {
    margin-bottom: 10px;
  }
  
  .file-list {
    margin-bottom: 10px;
    
    .file-item {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 8px 12px;
      margin-bottom: 5px;
      background-color: #f5f7fa;
      border-radius: 4px;
      font-size: 14px;
      
      .file-name {
        flex: 1;
        color: #606266;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      
      .delete-btn {
        color: #f56c6c;
        margin-left: 10px;
        
        &:hover {
          color: #f78989;
        }
      }
    }
  }
}
</style>